export const instantDbAppId = "64b555f6-1fcd-4033-ac96-670fc77543a9";
export const agentFomoDomain = "f0mo.com";
export const nativeEventPagePath = "/event/";
export const eventPageUrl = (eventId: string) =>
  `https://${agentFomoDomain}${nativeEventPagePath}${eventId}`;
export const apiUrlPath = "/api";
export const agentFomoPhone = "972504244206";
export const americanAgentFomoPhone = "19175402861";
export const groupBotPhone = "972507102788";
export const nitzanEmail = "nizzanav@gmail.com";
export const uriEmail = "uri.valevski@gmail.com";
export const adminEmails = [nitzanEmail, uriEmail];
export const israelUsersGroupLink =
  "https://chat.whatsapp.com/G8h77OtbLQCLPH9BlKpwzW";
export const berlinUsersGroupLink =
  "https://chat.whatsapp.com/L5KYYnFSGfYJnl0L42IvJ4";
export const nycUsersGroupLink =
  "https://chat.whatsapp.com/Cuo1Scun6O3B2LVpg0q9Cn";
export const developersFeedbackLink = israelUsersGroupLink;
export const allUsersGroupLinks = [
  israelUsersGroupLink,
  berlinUsersGroupLink,
  nycUsersGroupLink,
];
export const producersGroupLink =
  "https://chat.whatsapp.com/KW9qrC4MWFILicp8575VAc";
export const webAppUrl = "https://hi." + agentFomoDomain;
export const upgradeUrl = (phone?: string) =>
  phone
    ? `${webAppUrl}/upgrade?phone=${encodeURIComponent(phone)}`
    : `${webAppUrl}/upgrade`;
export const termsAndConditionsLink = `${webAppUrl}/terms`;
export const privacyPolicyLink = `${webAppUrl}/privacy`;
export const stripeProductId = "prod_UGfDpPPwBGRJHa";
export const stripePremiumSubscriptionPriceId =
  "price_1U96U2HiG8UAKPQvMdHF1Tui";
export const promotionCreditsPerPack = 50;
export const promotionCreditsCostCents = 5000;
export const freeTierMessageLimit = 30;
export const freeTierEventLimit = 20;
export const newEventBonusEvents = 10;
export const newEventBonusMessages = 10;
export const socialShareBonusEvents = 15;
export const socialShareBonusMessages = 15;
export const promoterMessageLimit = 1000;
export const freeTierApiRequestLimit = 20;
export const premiumTierApiRequestLimit = 1000;
export const maxApiRequestsPerMonth = freeTierApiRequestLimit;
export const monthInMs = 30 * 24 * 60 * 60 * 1000;
export const newUserQuotaGracePeriodMs = 14 * 24 * 60 * 60 * 1000;
export const isQuotaWindowExpired = (since: number, now: number): boolean =>
  since === 0 || now - since > monthInMs;
export const computeNextQuotaCounter = (
  currentCount: number,
  since: number,
  increment: number,
  now: number,
): { count: number; since: number } =>
  isQuotaWindowExpired(since, now)
    ? { count: increment, since: now }
    : { count: currentCount + increment, since };
export const minimumUserAge = 16;
export const twilioVerifyServiceSid = "VA3675867d2454d239e0edcab76422a974";
export const viewChatGroupId = "5b1a8908-2628-4bff-8ea1-09453cdf79d0";
// view-chat stores conversations under autobotbuilder/<botId>/<conversationId>
// and the conversations page matches conversationName with an $ilike suffix
// query, so the raw conversation id is enough to locate the thread.
export const viewChatConversationLink = (
  conversationId?: string | null,
  messageId?: string | null,
) =>
  conversationId && conversationId !== "current"
    ? `https://view-chat.com/conversations?groupId=${viewChatGroupId}&conversationName=${
      encodeURIComponent(conversationId)
    }${messageId ? `#${encodeURIComponent(messageId)}` : ""}`
    : null;
export const githubRepoOwner = "uriva";
export const githubRepoName = "agent-fomo";
